const USER_KEY = 'webhook_user'

export const setUserInfo = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export const getUserInfo = () => {
  const userStr = localStorage.getItem(USER_KEY)
  if (!userStr) return null
  return JSON.parse(userStr)
}

export const removeUserInfo = () => {
  localStorage.removeItem(USER_KEY)
}

// 获取默认头像文本
export const getAvatarText = (name) => {
  if (!name) return '管'
  return name.charAt(0).toUpperCase()
} 